import React from 'react';
import cn from 'classnames';
import styles from './SocialProof.module.scss';
import { AppleIcon } from '@components/Icons/IntegrationIcons';

const Wreath = ({ className }: { className?: string }) => (
  <svg className={cn(styles.wreath, className)} width="22" height="64" viewBox="0 0 28 80">
    <path d="M16.4 12.1C2.7 33.2 6.6 62.7 27.5 78.6c.4.4.6.9.4 1.2-.2.3-.8.3-1.2-.1A49.62 49.62 0 0 1 8.4 48c-1.9-12.6.9-25.4 8-35.9Zm1.1 59.4c-2.9 2.5-8.7.4-11.6-5.4 3.5-1.7 8.2 1 11.6 5.4Zm3.1-13.1c1.9 3.9 1.9 8.8-1 11.4-3.4-4.4-2.4-9.8 1-11.4Zm-8.5 4.4c-3.3 2-8.5-1.2-10.2-7.4 3.7-.9 7.7 2.6 10.2 7.4Zm5.7-12c1.1 4.2.1 9-3.3 10.8h-.1c-2.4-4.9-.3-9.9 3.4-10.8Zm-9.2 2.7C4.9 54.7.5 50.6 0 44.2c3.8-.2 7.1 4.1 8.6 9.3Zm7.9-10.6c.3 4.3-1.7 8.7-5.4 9.9v-.1c-1.4-5.2 1.5-9.6 5.4-9.8ZM.3 32.8c3.8.7 6.2 5.5 6.6 10.8-3.8.5-7.4-4.4-6.6-10.8Zm16.4 2.1c-.6 4.3-3.3 8.1-7.1 8.6l-.1-.1c-.3-5.3 3.4-9.1 7.2-8.5Zm1.7-7.8c-1.3 4.1-4.8 7.3-8.6 6.9.6-5.3 5-8.3 8.6-6.9ZM2.7 21.7c3.5 1.4 5 6.5 4.5 11.7l-.1.3H7C3.3 33.2.8 28 2.6 22l.1-.3Zm18.9-2.1c-2.2 3.8-6.1 6.3-9.8 5.2 1.6-5.1 6.5-7.3 9.8-5.2ZM7.3 11.2c3.2 2.1 3.6 7.6 2 12.8-3.7-1.1-5.3-7.1-2-12.8Zm19 1.6c-3 3.4-7.4 5.1-10.8 3.3 2.7-4.8 8.1-6 10.8-3.3ZM13.9 1.6c2.8 2.8 2 8.4-.7 13.1-3.3-1.8-3.7-8 .7-13.1Zm14-1.6c-1.8 4.7-5.6 8.4-10.2 10.2C17.7 5.4 22.9.1 27.9 0Z" />
  </svg>
);

export default function Award() {
  return (
    <div className={styles.award}>
      <Wreath className={styles.wreathLeft} />
      <div className={styles.awardInfo}>
        <div className={cn(styles.awardImage)}>
          20
          <AppleIcon width="16" height="21" />
          23
        </div>
        <h4>Essential CRM apps</h4>
        <h5>Business Category</h5>
      </div>
      <Wreath className={styles.wreathRight} />
    </div>
  );
}
